import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TsBadgeComponent } from './ts-badge.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule],
  declarations: [TsBadgeComponent],
  exports: [TsBadgeComponent],
})
export class TsBadgeModule {}
